import { esc } from '@/utils/escape';

export function generateAuthorityHTML(data: any, settings: any): string {
  const variant = data.variant || "chips";
  const items = (data.items || [])
    .map((it: any) => {
      const icon = it.icon
        ? `<span class="authority__icon">${esc(it.icon)}</span>`
        : `<span class="authority__icon">✅</span>`;
      return variant === "list"
        ? `<li class="authority__item">${icon}<span>${esc(it.text || "")}</span></li>`
        : `<div class="authority__chip">${icon}<span>${esc(it.text || "")}</span></div>`;
    })
    .join("\n");

  return `  <!-- Authority Strip -->
  <section class="authority">
    <div class="container">
      ${data.title ? `<h2 class="authority__title">${esc(data.title)}</h2>` : ""}
      ${
        variant === "list"
          ? `<ul class="authority__list">${items}</ul>`
          : `<div class="authority__chips">${items}</div>`
      }
    </div>
  </section>`;
}
